import { fetchApi } from 'api/fetchApi'
import { paths } from 'api/generated/photorating'

/**
 * https://developers.wamba.com/api/services/photorating/index.html
 */

type Method = paths['/ratings/featured_photos/photos']
type Result = Method['get']['responses']['200']['schema']

export const fetchPhotoRatingActiveListApi = () =>
  fetchApi<Result>('/ratings/featured_photos/photos')
